const testimonials = [
  {
    name: "Travis B.",
    location: "Gray, LA",
    rating: 5,
    text: "I work offshore in West Africa on a 28/28 rotation. Got a contract modification to mobilize to Equatorial Guinea and my passport had expired. Called Fast Passport Center on Monday, shipped my documents Tuesday morning from Houma, and had a new passport Friday. Made my Sunday mobilization. These guys understand offshore workers — they do not mess around.",
    service: "Emergency Renewal",
  },
  {
    name: "Michelle & Chris D.",
    location: "Houma, LA",
    rating: 5,
    text: "We booked a Caribbean cruise out of New Orleans for our anniversary and realized three weeks before sailing that my passport was expired and our teenage daughter had never had one. Fast Passport Center handled both simultaneously — my renewal and her first passport. We had both in hand a week before sailing. Couldn't have been easier.",
    service: "Family Passport — Renewal + First-Time",
  },
  {
    name: "Captain Dale F.",
    location: "Thibodaux, LA",
    rating: 5,
    text: "I operate marine supply vessels and had a crew change in Rotterdam come up fast. My company needed me on the vessel in 8 days. Passport was current but one of my crew members had an expired one. Fast Passport Center processed his renewal in 4 business days. We made the crew change on time. I will not use anyone else for my crew's passport needs.",
    service: "Maritime Crew Emergency Renewal",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function HoumaTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Bayou Region Travelers Say About Our Emergency &amp; Expedited Passport Service
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from Houma, Gray, and Thibodaux travelers who trusted Fast Passport Center with their expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div key={i} className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col">
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}